import getPixelsForPercentageOfDocument from 'utilities/locationLogic/getPixelsForPercentageOfDocument';

/**
 * @method scrollToPercentage
 * @param {Element} frame
 * @param {Number} float representing a percentage of the content, from 0 to 1
 */
const scrollToPercentage = (frame, percentage) => {
  const newScrollTop = getPixelsForPercentageOfDocument(frame, percentage);

  frame.parentElement.parentElement.scrollTop = newScrollTop;
};

export default scrollToPercentage;
